import React from 'react';
import { Modal } from 'react-bootstrap';

const ModalComponent = ({ show, handleClose }) => {
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Modal Title</Modal.Title>
            </Modal.Header>
            <Modal.Body>Modal Body</Modal.Body>
            <Modal.Footer>
                <button onClick={handleClose}>Close</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalComponent;
